import React from 'react';
import { ArrowLeft, Clock, Sparkles } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const ComingSoon = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 via-gray-800 to-black text-white flex items-center justify-center relative overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl animate-pulse delay-1000"></div>
      </div>

      {/* Back button */}
      <button
        onClick={handleBack}
        className="fixed top-8 left-8 z-50 flex items-center space-x-2 bg-black/70 backdrop-blur-sm text-white px-6 py-3 rounded-full hover:bg-black/90 transition-all shadow-lg hover:scale-105"
      >
        <ArrowLeft className="w-5 h-5" />
        <span className="font-semibold">Back</span>
      </button>

      {/* Main content */}
      <div className="relative z-10 text-center px-4 max-w-2xl">
        <div className="mb-8 relative inline-block">
          <div className="absolute inset-0 bg-gradient-to-r from-purple-500 to-blue-500 rounded-full blur-2xl opacity-30 animate-pulse"></div>
          <Clock className="w-32 h-32 text-white relative animate-bounce" strokeWidth={1.5} />
        </div>

        <div className="flex items-center justify-center gap-2 mb-6">
          <Sparkles className="w-6 h-6 text-yellow-400 animate-pulse" />
          <h1 className="text-6xl md:text-7xl font-bold bg-gradient-to-r from-purple-400 via-pink-400 to-blue-400 bg-clip-text text-transparent">
            Coming Soon
          </h1>
          <Sparkles className="w-6 h-6 text-yellow-400 animate-pulse" />
        </div>

        <p className="text-xl md:text-2xl text-gray-300 mb-8">
          We're working hard to bring you something amazing!
        </p>

        <p className="text-gray-400 text-lg mb-12">
          This feature is currently under development and will be available soon. Stay tuned for updates!
        </p>

        {/* Animated progress indicator */}
        <div className="max-w-md mx-auto">
          <div className="h-2 bg-gray-700 rounded-full overflow-hidden">
            <div className="h-full bg-gradient-to-r from-purple-500 via-pink-500 to-blue-500 rounded-full animate-pulse w-3/4"></div>
          </div>
          <p className="text-sm text-gray-500 mt-3">In Progress...</p>
        </div>

        {/* Decorative elements */}
        <div className="mt-16 flex justify-center gap-4">
          <div className="w-3 h-3 bg-purple-500 rounded-full animate-bounce"></div>
          <div className="w-3 h-3 bg-pink-500 rounded-full animate-bounce delay-200"></div>
          <div className="w-3 h-3 bg-blue-500 rounded-full animate-bounce delay-400"></div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;